<div class="option-selection">
	<h3 class="drawer-dialog-content-header">{{ labelText }}</h3>
	<div class="row spacing-24">
		<mat-form-field subscriptSizing="dynamic" appearance="outline" class="column" style="width: 100%">
			<mat-icon matPrefix matListIcon class="primary-icon-color" [svgIcon]="'sl-search'"></mat-icon>
			<input
				matInput
				type="text"
				placeholder="{{ placeholderText }}"
				class="placeholder-text"
				#searchOptionsInput
				[formControl]="searchOptionsCtrl"
				#trigger="matAutocompleteTrigger"
				[matAutocomplete]="selectOptionsAuto"
				[attr.autofocus]="autoFocus ? '' : null"
				(focus)="hasFocus = true"
				(blur)="onInputBlur()"
				data-automation-id="typeahead-input"
			/>
			<mat-autocomplete
				disableOptionCentering
				#selectOptionsAuto="matAutocomplete"
				[displayWith]="displayDropdownOptionFn"
				(optionSelected)="optionSelected($event)"
			>
				@for (option of filteredDropdownOptions | async; track option[filterOnField]) {
					<mat-option [value]="option" [attr.data-automation-id]="'typeahead-option-' + option[filterOnField]">
						<mat-checkbox [checked]="optionsList.has(option)" style="margin-right: 8px">{{
							option[filterOnField]
						}}</mat-checkbox>
					</mat-option>
				}
			</mat-autocomplete>
			@if (!hasFocus) {
				<mat-icon (click)="openOrClosePanel($event, trigger)" matSuffix matListIcon class="primary-icon-color"
					>keyboard_arrow_down</mat-icon
				>
			}
			@if (hasFocus) {
				<mat-icon (click)="openOrClosePanel($event, trigger)" matSuffix matListIcon class="primary-icon-color"
					>keyboard_arrow_up</mat-icon
				>
			}
		</mat-form-field>
	</div>
</div>

@if (showSelectionsBelowInputField) {
	@for (selectedOption of optionsList; track selectedOption[filterOnField]) {
		<div
			class="assignment-option flex-column-margin-top"
			[attr.data-automation-id]="'typeahead-option-' + selectedOption[filterOnField]"
		>
			<div class="flex-row-space-between">
				<div class="flex-row-end">
					<mat-icon [svgIcon]="selectedItemIconName" class="multi-select-circle-icon"></mat-icon>
					<span class="selected-option-text">{{ extractNameFromDisplayName(selectedOption[filterOnField]) }}</span>
				</div>
				<div class="center-horizontally">
					<a
						(click)="removeOption(selectedOption)"
						class="remove-link"
						i18n="@@assignDeviceControl-removeUserOrCompany"
						[attr.data-automation-id]="'remove-' + selectedOption[filterOnField] + '-button'"
						>Remove</a
					>
				</div>
			</div>
			@if (showSelectedItemSubOption) {
				<div class="suboption-container" style="margin-left: 3.5rem">
					<span class="checkbox-label">
						<mat-checkbox
							[(ngModel)]="selectedOption[subOptionFieldName]"
							style="margin-right: 8px"
							[attr.data-automation-id]="'option-' + selectedOption[filterOnField] + '-checkbox'"
						></mat-checkbox>
						<span class="suboption-text">{{ subOptionText }}</span>
						<mat-icon svgIcon="sl-info-square" matTooltip="{{ subOptionTooltip }}"></mat-icon>
					</span>
				</div>
			}
			@if (showSelectedItemMessage && !selectedOption[showMessageFieldName]) {
				<div class="flex-row-end not-all-sub-authorized-text">
					{{ showMessageText }}
				</div>
			}
		</div>
	}
}
